import './App.css';
import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from './routes/PrivateRoute';
import MainLayout from "./components/layout/MainLayout";
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import Unauthorized from "./components/layout/Unauthorized";
import PageNotFound from "./components/layout/PageNotFound";
import AdminLayout from "./components/layout/AdminLayout";
import UserLayout from "./components/layout/UserLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UserDashboard from "./pages/user/UserDashboard";
import HomePage from "./components/home/Home";
import Setting from './pages/setting/Setting';
import City from './pages/city/City';
import Country from './pages/country/Country';
import State from './pages/state/State';
import UserRole1 from './pages/userRole/UserRole1';
import UserView from './pages/userRole/UserView';
import ItemManage from './pages/itemManage/ItemManage';
import Item from './pages/item/ItemIndex';
import ItemCreate from './pages/item/ItemCreate';
import ItemView from './pages/item/ItemView';
import Client from './pages/client/ClientIndex';
import ClientCreate from './pages/client/ClientCreate';
import ClientView from './pages/client/ClientView';
import RoleCreate1 from './pages/userRole/RoleCreate1';
import { hasAccess } from "./utils/permissionHelper";
import UserCategory from './pages/userCategory/UserCategory';
import CompanyTypes from './pages/companyTypes/CompanyTypes';
import Price from './pages/priceList/PriceIndex';
import ClientOffer from './pages/priceList/ClientOffer';
import ClientOfferView from './pages/priceList/ClientOfferView';
import StateOffer from './pages/priceList/StateOffer';
import CategoryOffer from './pages/priceList/CategoryOffer';
import CategoryView from './pages/priceList/CategoryView';
import StateView from './pages/priceList/StateView';
import Order from './pages/order/OrderIndex';
import OrderCreate from './pages/order/OrderCreate';
import OrderView from './pages/order/OrderView';
import Report from './pages/report/Report';

function App() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const readUserFromStorage = () => {
            try {
                const storedUser = localStorage.getItem("user");
                if (storedUser) {
                    setUser(JSON.parse(storedUser));
                } else {
                    setUser(false);
                }
            } catch (err) {
                console.error("Failed to read/parse user from localStorage:", err);
                setUser(false);
            }
        };

        readUserFromStorage();

        const onUserChanged = () => readUserFromStorage();
        const onStorage = (e) => {
            if (!e) return;
            if (e.key === "user") readUserFromStorage();
        };

        window.addEventListener("userChanged", onUserChanged);
        window.addEventListener("storage", onStorage);

        return () => {
            window.removeEventListener("userChanged", onUserChanged);
            window.removeEventListener("storage", onStorage);
        };
    }, []);

    if (user === null) {
        return <div>Loading...</div>;
    }

    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route element={<MainLayout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
            </Route>

            <Route
                path="/admin"
                element={
                    <PrivateRoute allowedRoles={["SuperAdmin"]}>
                        <AdminLayout />
                    </PrivateRoute>
                }
            >
                <Route index element={<AdminDashboard />} />
                {hasAccess(user, "User", "List") && (
                    <Route path="userRole" element={<UserRole1 />} />
                )}
                {hasAccess(user, "User", "View") && (
                    <Route path="userRole/view/:id" element={<UserView />} />
                )}
                {hasAccess(user, "User", "Create") && (
                    <Route path="userRole/create" element={<RoleCreate1 />} />
                )}
                {hasAccess(user, "User", "Edit") && (
                    <Route path="userRole/edit/:id" element={<RoleCreate1 />} />
                )}

                {/* client */}
                    <Route path="client" element={<Client />} />
                    <Route path="client/create" element={<ClientCreate />} />
                    <Route path="client/edit/:id" element={<ClientCreate />} />
                    <Route path="client/view/:id" element={<ClientView />} />
                {/* Item */}
                
                    <Route path="itemManage" element={<ItemManage />} />
                    <Route path="item" element={<Item />} />
              
                
                    <Route path="item/create" element={<ItemCreate />} />
              
                
                    <Route path="item/edit/:id" element={<ItemCreate />} />
                
                
                    <Route path="item/view/:id" element={<ItemView />} />
             
                <Route path="price" element={<Price />} />
                <Route path="clientOffer" element={<ClientOffer />} />
                <Route path="stateOffer" element={<StateOffer />} />
                <Route path="categoryOffer" element={<CategoryOffer />} />
                <Route path="clientOffer/edit/:id" element={<ClientOffer />} />
                <Route path="stateOffer/edit/:id" element={<StateOffer />} />
                <Route path="categoryOffer/edit/:id" element={<CategoryOffer />} />
                <Route path="clientOffer/view/:id" element={<ClientOfferView />} />
                <Route path="state/view/:id" element={<StateView />} />
                <Route path="category/view/:id" element={<CategoryView />} />
                <Route path="setting" element={<Setting />} />
                <Route path="city" element={<City />} />
                <Route path="state" element={<State />} />             
                <Route path="country" element={<Country />} />
                <Route path="userCategory" element={<UserCategory />} />
                <Route path="companyTypes" element={<CompanyTypes />} />
                <Route path="order" element={<Order />} />
                <Route path="order/create" element={<OrderCreate />} />
                <Route path="order/edit/:id" element={<OrderCreate />} />
                <Route path="order/view/:id" element={<OrderView />} />
                <Route path="report" element={<Report />} />
            </Route>

            {/* User protected routes with permission check */}
            <Route
                path="/user"
                element={
                    <PrivateRoute allowedRoles={["Client"]}>
                        <UserLayout />
                    </PrivateRoute>
                }
            >
                   <Route index element={<UserDashboard />} />                
                    <Route path="client" element={<Client />} />
                    <Route path="client/create" element={<ClientCreate />} />
                    <Route path="client/edit/:id" element={<ClientCreate />} />
                    <Route path="client/view/:id" element={<ClientView />} />

                {/* Item */}
                    <Route path="order" element={<Order />} />
                    <Route path="order/create" element={<OrderCreate />} />
                    <Route path="order/edit/:id" element={<OrderCreate />} />
                    <Route path="order/view/:id" element={<OrderView />} />
            </Route>

            {/* Common dashboard for all authenticated users */}
            <Route
                path="/login"
                element={
                    <PrivateRoute allowedRoles={["Company Admin", "SuperAdmin"]}>
                        <Login />
                    </PrivateRoute>
                }
            />

            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default App;